import React, { useState, useEffect, useMemo } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Link } from "react-router-dom";
import ModalTask from "./ModalTask";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";

import lottie from "lottie-web";

const service_initial_value = [
  {
    id: null,
    service_name: "",
    quantity_type: "",
    status: "",
  },
];

const table_config = {
  key_column: "id",
  page_size: 10,
  length_menu: [10, 20, 50],
  show_filter: true,
  show_pagination: true,
  button: {
    excel: false,
    print: false,
  },
  language: {
    loading_text: "Please be patient while data loads...",
  },
};

const table_header = [
  {
    name: "ID",
    width: "10"
  },
  {
    name: "Task Name",
    width: "30",
  },
  {
    name: "Service",
    width: "30",
  },
  {
    name: "",
    width: "30"
  }
]

export default function OutletTask(props: any) {
  const [service_data, SetServiceData] = useState(service_initial_value);
  const [is_loading, SetIsLoading] = useState(false);
  const [Modal, SetModal] = useState({ open: false, type: "" });
  const [start_work, SetStartWork] = useState(false);
  const [work_service_data, SetWorkServiceData] = useState({});
  // const [brand_id, SetBrandId] = useState(7);
  // const [outlet_id, SetOutletId] = useState(13);
  const [id_value, SerIdValue] = useState(useParams());
  const table_column = [
    { key: "id", text: "Id", sortable: true },
    { key: "service_name", text: "Task Name", sortable: true },
    {
      key: "quantity_type",
      text: "Service",
      cell: (record: any, index: any) => {
        if (record.quantity_type == 1) {
          return "Item Wise";
        } else {
          return "Duration Wise";
        }
      },
      sortable: true,
    },
    {
      key: "action",
      text: "Action",
      width: 250,
      className: "text-center",
      align: "center",
      cell: (record: any, index: any) => {
        return (
          <div>
            {record.hasOwnProperty("status") ? (
              <button
                className="btn btn-warning btn-sm"
                onClick={() => {
                  ResumeOptions(record.id);
                  console.log("Resume");
                }}
                style={{ marginRight: "5px" }}
              >
                <i className="fas fa-play"></i>
                &nbsp; Resume
              </button>
            ) : (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  SetStartWork(true);
                  StartOptions(record.id);
                  console.log("Start");
                }}
                style={{ marginRight: "5px" }}
              >
                <i className="fas fa-hourglass-start"></i>
                &nbsp; Start
              </button>
            )}
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    console.log("OutletService On mount :", props);
    get_assign_services();
  }, []);

  function ModalOpen(data: any) {
    SetModal({ open: true, type: data });
  }

  function ModalClose(data: any) {
    SetModal({ open: false, type: data });
    console.log("Modal Data: ", data);
    get_assign_services();
  }

  async function StartOptions(id: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        task_id: id,
      },
    };
    let data = await api("/outlet/service_work_start", pass_data);
    console.log("Start response :", data);
    get_assign_services();
  }

  async function ResumeOptions(id: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        task_id: id,
      },
    };
    let data = await api("/outlet/service_work_resume", pass_data);
    console.log("Resume response :", data);
    get_assign_services();
  }

  async function get_assign_services() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };
    let data = await api("/outlet/user_assigned_services", pass_data);
    console.log("response :", data.response);
    if (data.response.hasOwnProperty("services")) {
      SetServiceData(data.response.services);
    } else {
      SetServiceData([]);
    }
    if (data.response.hasOwnProperty("working_service")) {
      SetWorkServiceData(data.response.working_service);
      console.log("Work response :", data.response.working_service.files);
    } else {
      SetWorkServiceData({});
    }
  }

  return (
    <div>
      <div className="bg-fff pt-3 px-4 ">
        <h5 className="  mb-0 text-dark fw-bolder">Tasks</h5>
      </div>
      <div className="container-fluid py-3">

        {Object.keys(work_service_data).length !== 0 ? (
          <div className=" p-2 mt-4">
            <h6>Ongoing works</h6>
            <div className="task-card mt-3">
              <div className="row align-item-center">
                <div className="col-md-4">
                  <h4 id="type">{work_service_data.service_name}</h4>
                </div>
                <div className="col-md-8 mt-sm-2 p-0">
                  <div className="d-flex  align-item-center justify-content-end">
                    <p>
                      <i className="fas fa-hourglass-start pe-1"></i>{" "}
                      {work_service_data.started_at}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="d-flex">
                    <p className="pe-3">Id</p>
                    <p className="">
                      <b>{work_service_data.id}</b>
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="pe-3">Client Name</p>
                    <p className="">
                      <b>{work_service_data.client_name}</b>
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="pe-3">File location</p>
                    {/* {work_service_data.files.map((file, index) => (
                                                    <p className="" key={index}><b>{file.file_path}</b></p>
                                                ))} */}
                  </div>
                </div>
                <div className="col-md-4 p-0 center mt-sm-2">
                  <div className="row text-center">
                    <div className="col-6">
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          ModalOpen("pause");
                        }}
                      >
                        <i className="fas fa-pause pe-3"></i> Pause
                      </button>
                    </div>
                    <div className="col-6 ">
                      <button
                        className="btn btn-success"
                        onClick={
                          () => {
                            ModalOpen("finish");
                          }
                          // ModalOpen("finish")
                        }
                      >
                        <i className="fas fa-check pe-3"></i> Finish
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="card px-4 py-3">
          <div className="row p-3">
            <div className="col-md-8 pb-2">
              <div className="d-flex align-items-center">
                <p className="mb-0 pe-2">Show</p>
                <select className="form-select flex-basis-20" defaultValue={10} aria-label="Default select example">
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                </select>
                <p className="mb-0 ps-2">records per page</p>
              </div>
            </div>
            <div className="col-md-4 pb-2 text-end">
              <input type="text" className="form-control" id="staticEmail" placeholder="Search in recors..." />
            </div>
          </div>

          <table className="table table-hover">
            <thead className="table-headers">
              {table_header.map((head, t_index) => (
                <div className={"custom-table-header flex-basis-" + head.width} key={t_index}>
                  <p>{head.name}</p>
                </div>
              ))}
            </thead>
            <tbody >
              {service_data.map((data, ser_index) => (
                <div className="custom-table-row" key={ser_index}>
                  <div className="custom-table-cell flex-basis-20">
                    <span className="mobile-column-name">
                      ID
                    </span>
                    <div className="center-wrapper">
                      <p>{data.id}</p>
                    </div>
                  </div>
                  <div className="custom-table-cell flex-basis-50">
                    <span className="mobile-column-name">
                      Task Name
                    </span>
                    <div className="center-wrapper">
                      <p className="mb-1">{data.service_name}</p>
                    </div>
                  </div>
                  <div className="custom-table-cell flex-basis-50">
                    <span className="mobile-column-name">
                      Service
                    </span>
                    <div className="center-wrapper">
                      {data.quantity_type == 1 ? (
                        <p>Item Wise</p>
                      ) : (
                        <p>Duration Wise</p>
                      )}
                    </div>
                  </div>
                  <div className="custom-table-cell flex-basis-30 action-cell">
                    {/* <span className="mobile-column-name">
                    Action
                  </span> */}
                    <div className="center-wrapper cursor">
                      <div>
                        {data.hasOwnProperty("status") ? (
                          <button
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              ResumeOptions(data.id);
                              console.log("Resume");
                            }}
                            style={{ marginRight: "5px" }}
                          >
                            <i className="fas fa-play"></i>
                            &nbsp; Resume
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                              SetStartWork(true);
                              StartOptions(data.id);
                              console.log("Start");
                            }}
                            style={{ marginRight: "5px" }}
                          >
                            <i className="fas fa-hourglass-start"></i>
                            &nbsp; Start
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </tbody>
          </table>

          <div className="row align-items-center p-3">
            <div className="col-md-4">
              <p>Showing 1 to 8 of 8 enteries </p>
            </div>
            <div className="col-md-8">
              <nav className="Pager1" aria-label="pagination example">
                <ul className="pagination pagination-circle justify-content-center">

                  <li className="page-item disabled"><a className="page-link">First</a></li>

                  <li className="page-item disabled">
                    <a className="page-link" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </a>
                  </li>

                  <li className="page-item active"><a className="page-link">1</a></li>
                  <li className="page-item"><a className="page-link">2</a></li>
                  <li className="page-item"><a className="page-link">3</a></li>
                  <li className="page-item"><a className="page-link">4</a></li>
                  <li className="page-item"><a className="page-link">5</a></li>

                  <li className="page-item">
                    <a className="page-link" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span className="sr-only">Next</span>
                    </a>
                  </li>

                  <li className="page-item"><a className="page-link">Last</a></li>

                </ul>
              </nav>
            </div>
          </div>
        </div>

        {/* <div className="mt-4">
          <ReactDatatable
            className="table custom-style-table"
            tHeadClassName="custom-header-style"
            config={table_config}
            records={service_data}
            columns={table_column}
            loading={is_loading}
          />
        </div> */}

        <ModalTask
          open={Modal.open}
          close={(data: any) => {
            ModalClose(data);
          }}
          data={work_service_data}
          type={Modal.type}
        />
      </div>
    </div>
  );
}
